import firebase from 'firebase/app';
import 'firebase/database'
import 'firebase/auth'

const configOptions = {
  apiKey: "AIzaSyCIo2GmJ4mT8L_aXN4im486jtva9Hq5VvU",
  authDomain: "convodo2.firebaseapp.com",
  databaseURL: "https://convodo2.firebaseio.com",
  projectId: "convodo2",
  storageBucket: "convodo2.appspot.com",
  messagingSenderId: "974936691702",
  appId: "1:974936691702:web:482f43ca7ffa283db4add7",
  measurementId: "G-MDZ0N5RVGZ"
};

firebase.initializeApp(configOptions);



export default firebase
export const db = firebase.database()
